import { ButtonBase as MuiButtonBase } from '@mui/material';
import type { ButtonBaseProps as MuiButtonBaseProps } from '@mui/material/ButtonBase';

export type ButtonBaseProps = MuiButtonBaseProps;

export const ButtonBase = ({ ...rest }: ButtonBaseProps): JSX.Element => (
  <MuiButtonBase {...rest} />
);
